import { DatePicker as FabricDatePicker, IDatePickerProps, IDatePickerStyles } from "@fluentui/react";
import React from "react";

import { useDateRender } from "../../../hooks";
import { usePrevious } from "../../../hooks/use-previous/usePrevious";

export interface DatePickerProps
    extends Pick<
        IDatePickerProps,
        "value" | "minDate" | "maxDate" | "formatDate" | "label" | "placeholder" | "styles"
    > {
    testId?: string;
    onDateSelect(date?: Date): void;
}

export const DatePicker: React.FunctionComponent<DatePickerProps> = (props: DatePickerProps) => {
    const prevValue = usePrevious(props.value || null);
    const value = props.value ? new Date(props.value?.toISOString().split("T")[0]) : undefined;
    const { renderDate } = useDateRender();

    const setSelectedDate = (date?: Date | null): void => {
        if (prevValue?.getDate() !== date?.getDate()) {
            const newDate = date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : undefined;
            props.onDateSelect(newDate);
        }
    };

    const formatDate = (date?: Date): string => {
        if (props.formatDate) {
            return props.formatDate(date);
        }

        return date ? renderDate(date) : "";
    };

    return (
        <FabricDatePicker
            styles={{ ...props.styles, ...goTodayFixStyles }}
            underlined={true}
            allowTextInput={false}
            formatDate={formatDate}
            onSelectDate={setSelectedDate}
            value={value}
            label={props.label}
            placeholder={props.placeholder}
            minDate={props.minDate}
            maxDate={props.maxDate}
            showCloseButton={true}
            data-testId={props.testId}
        />
    );
};

const goTodayFixStyles: Partial<IDatePickerStyles> = {
    callout: {
        selectors: {
            // Be wary of this styling hack: https://stackoverflow.com/a/60310536/479836
            // It's here as a temporary fix for this Github issue: https://github.com/microsoft/fluentui/issues/13991
            "& .ms-DatePicker-goToday": { right: 15 }
        }
    }
};
